import styled from 'styled-components';

import * as Common from '../../../Styles';

const Theme = Common.Theme;

export const DialogBox = styled(Common.DialogBox)``;
